//============================================================

// -- kv

//============================================================

var screenWidth,
    screenHeight,
    scr;

var store = {

    Navi: $('.l-store__navi'),
    List: $('.l-store__list__link'),
    posiStart : 0,
    posiEnd : 0,
    storePosi : [],
    Index:0,
    init : function () {
        store.List.click(function(){
            if($(window).width() < 750){
                var _link = $(this).find('a').attr('href');
                var _target = $(this).find('a').attr('target');
                if(_target === '_blank'){
                    window.open(_link, '_blank');
                }else{
                    location.href = _link;
                }
                return false;
            }
        });
    },
    set : function () {
        // navi
        if(scr > store.posiStart){
            store.Navi.addClass('active');
            if(scr > store.posiEnd){
                store.Navi.removeClass('active');
            }
        }else{
            store.Navi.removeClass('active');
        }
        // store
        for (var i=-1; i<store.List.length; i++) {
            if(scr > store.storePosi[i]){
                store.Navi.find('li').removeClass('current');
                store.Navi.find('li').eq(i).addClass('current');
            }
        }
    },
    move: function () {
        store.Navi.find('li').find('a').on('click',function(){
            store.Index = $(this).parent('li').index();
            $('html,body').animate({scrollTop: store.storePosi[store.Index]}, 150);
            return false;
        });
    }

}

var brand = {

    Parent : $('.l-original-brands'),
    List : $('.l-original-brands__list>ul>li'),
    Bg : $('.l-original-brands__bg'),
    Name : '',

    init : function () {

        brand.List.hover(
            function () {
                brand.Name = $(this).data('brand');
                TweenLite.set($('#l-original-brands__bg-'+brand.Name),
                    {
                        opacity:0,
                        display:'none',
                        scale: 1.04,
                        // '-webkit-filter': 'blur(5px)',
                        // 'filter': 'blur(5px)',
                    }
                );
                TweenMax.to($('#l-original-brands__bg-'+brand.Name), 0.36,
                    {
                        opacity:1,
                        display:'block',
                        scale: 1,
                        // '-webkit-filter': 'blur(0px)',
                        // 'filter': 'blur(0px)',
                        ease: Circ.easeOut
                    }
                );
                brand.Parent.addClass('hover');
            },
            function () {
                brand.Name = $(this).data('brand');
                TweenMax.to($('#l-original-brands__bg-'+brand.Name), 0.36,
                    {
                        opacity:0,
                        display:'none',
                        scale: 1.04,
                        // '-webkit-filter': 'blur(5px)',
                        // 'filter': 'blur(5px)',
                        ease: Circ.easeOut
                    }
                );
                brand.Parent.removeClass('hover');
            }
        );

    },

    animation : function () {

    }

}

//============================================================

// -- motion

//============================================================

var motion = {

    text:function(target){

        TweenMax.staggerTo(target.children().children(), 0.23,
            {
                rotation:0,
                transformOrigin:"right bottom",
                ease: Circ.easeOut
            },
            0.09
        );
    },

    hideY:function(target){

        TweenMax.to(target.find(".target"), 0.86,
            {
                y:'0%',
                ease: Circ.easeOut
            }
        );
    }

};

//============================================================

// -- resize

//============================================================

var resize = {
    init:function(){
        screenWidth = $(window).width();
        screenHeight = $(window).height();
    }

};

if($('#p-top')[0]){
    brand.init();
    store.init();
    // store.move();
}

$(window).on('resize',function () {
    if(!$('#p-top')[0]) return false;
    // store.init();
});
$(window).on('scroll',function () {
    if(!$('#p-top')[0]) return false;
    scr = $(window).scrollTop() + $(window).height() / 3;
    // store.set();
});
